<!--
 * @Version: 1.2
 * @Author: admin
 * @Description: menu
 * @Date: 2022-06-23 14:44:40
 * @LastEditors: sky
 * @LastEditTime: 2022-09-15 11:38:51
-->
<script lang="tsx">
import {defineComponent, ref, h, compile, computed, nextTick} from "vue";
import {useRouter, RouteRecordRaw, RouteRecordNormalized} from "vue-router";
import {useAppStore, useUserStore} from "@/store";
//import usePermission from "@/hooks/permission";
import {listenerRouteChange} from "@/utils/route-listener";
import examine from "@/router/routes/modules/examine";

export default defineComponent({
  emit: ["collapse"],
  setup() {
    const appStore = useAppStore();
    const userStore = useUserStore();
    //const permission = usePermission();
    const router = useRouter();
    const collapsed = computed({
      get() {
        if (appStore.device === "desktop") return appStore.menuCollapse;
        return false;
      },
      set(value: boolean) {
        appStore.updateSettings({menuCollapse: value});
      },
    });
    const mergeRoute = (root, data) => {
      data.forEach((i) => {
        i.prefix = i.path.substring(7).split("/");
        i.level = i.prefix.length;
        i.levelName = i.prefix[0];
        if (i.level == 1) i.children = [];
      });
      let level1 = data.filter((i) => i.level === 1);
      let level2 = data.filter((i) => i.level === 2);
      level2.forEach((i) => {
        level1.forEach((e) => {
          if (e.levelName === i.levelName) {
            e.children.push(i);
          }
        });
      });
      if (level1.length > 0) {
        root.children = level1;
        return root;
      } else {
        return root;
      }
    };
    const mergeAppRoute = (root, data) => {
      data.forEach((i) => {
        i.prefix = i.path.substring(5).split("/");
        i.level = i.prefix.length;
        i.levelName = i.prefix[0];
        if (i.level == 1) i.children = [];
      });
      let level1 = data.filter((i) => i.level === 1);
      let level2 = data.filter((i) => i.level === 2);
      level2.forEach((i) => {
        level1.forEach((e) => {
          if (e.levelName === i.levelName) {
            e.children.push(i);
          }
        });
      });
      root.children = level1;
      return root;
    };
    const appRoute = computed(() => {
      if (!userStore.loginBarrackId) {
        let rootRoute = router.getRoutes().find((el) => el.name === "admin");
        let routesData = router.getRoutes().filter((el) => {
          if (typeof el.path === "string") {
            return el.path.includes("/admin/");
          }
        });
        let objRoutes = mergeRoute(rootRoute, routesData);
        return objRoutes;
      } else {
        let rootRoute = router.getRoutes().find((el) => el.name === "app");
        let routesData = router.getRoutes().filter((el) => {
          if (typeof el.path === "string") {
            return el.path.includes("/app/");
          }
        });
        let objRoutes = mergeAppRoute(rootRoute, routesData);
        return objRoutes;
      }
    });
    const menuTree = computed(() => {
      if (appRoute.value) {
        const copyRouter = appRoute.value.children;
        copyRouter.sort((a: RouteRecordNormalized, b: RouteRecordNormalized) => {
          return (a.meta.order || 0) - (b.meta.order || 0);
        });

        function travel(_routes: RouteRecordRaw[], layer: number) {
          if (!_routes) return null;
          const collector: any = _routes.map((element) => {
            // no access
            // if (!permission.accessRouter(element)) {
            //   return null;
            // }

            // leaf node
            if (!element.children) {
              return element;
            }

            // route filter hideInMenu true
            element.children = element.children.filter((x) => x.meta?.hideInMenu !== true);

            // Associated child node
            const subItem = travel(element.children, layer);
            if (subItem.length) {
              element.children = subItem;
              return element;
            }
            // the else logic
            if (layer > 1) {
              element.children = subItem;
              return element;
            }

            if (element.meta?.hideInMenu === false) {
              return element;
            }

            return null;
          });
          return collector.filter(Boolean);
        }

        return travel(copyRouter, 0);
      }
    });

    // In this case only two levels of menus are available
    // You can expand as needed

    const selectedKey = ref<string[]>([]);
    // const openName = ['leaderView','personAnalysis','trainView']
    const goto = (item: RouteRecordRaw) => {
      console.log(item);
      if (item.name == "leaderView") {
        window.open("/web/app/leader");
      } else if (item.name == "personAnalysis") {
        window.open("/web/app/person");
      } else if (item.name == 'trainView' || item.name == 'examView' || item.name == 'holoView') {
        window.open('/web' + item.path, '_blank');
      }else if(item.name == 'trainingBoard') {
        window.open('/web/h5/trainingBoard', '_blank');
      } else {
        router.push({
          name: item.name,
        });
      }
    };
    listenerRouteChange((newRoute) => {
      if (newRoute.meta.requiresAuth && !newRoute.meta.hideInMenu) {
        const key = newRoute.matched[newRoute.matched.length - 1]?.name as string;
        selectedKey.value = [key];
      }
    }, true);
    const setCollapse = (val: boolean) => {
      if (appStore.device === "desktop") appStore.updateSettings({menuCollapse: val});
    };

    const renderSubMenu = () => {
      function travel(_route: RouteRecordRaw[], nodes = []) {
        if (_route) {
          _route.forEach((element) => {
            // This is demo, modify nodes as needed
            const icon = element?.meta?.icon ? () => h(compile(`<${element?.meta?.icon}/>`)) : null;
            const r =
                element?.children && element?.children.length > 0 ? (
                    <a-sub-menu
                        key={element?.name}
                        v-slots={{
                          icon,
                          title: () => h(compile(element?.meta?.locale || "")),
                        }}
                    >
                      {travel(element?.children)}
                    </a-sub-menu>
                ) : (
                    <a-menu-item key={element?.name} v-slots={{icon}} onClick={() => goto(element)}>
                      {element?.meta?.locale || ""}
                    </a-menu-item>
                );
            nodes.push(r as never);
          });
        }
        return nodes;
      }

      return travel(menuTree.value);
    };

    return () => (
        <a-menu
            v-model:collapsed={collapsed.value}
            show-collapse-button={appStore.device !== "mobile"}
            auto-open={false}
            selected-keys={selectedKey.value}
            auto-open-selected={true}
            level-indent={34}
            style="height: 100%"
            onCollapse={setCollapse}
        >
          {renderSubMenu()}
        </a-menu>
    );
  },
});
</script>

<style lang="less" scoped>
:deep(.arco-menu-inner) {
  background: #274C7B;

  .arco-menu-selected {
    background: #2990E8 !important;
    color: #fff !important;

    .arco-icon {
      color: #fff !important;
    }
  }

  .arco-menu-pop {
    background: #274C7B;
    color: #fff;

    &:hover {
      background: #2990E8 !important;
      color: #fff !important;
    }
  }

  .arco-menu-item {
    background: #274C7B;
    color: #fff;

    &:hover {
      background: #2990E8 !important;
      color: #fff !important;
    }
  }

  .arco-menu-inline-header {
    display: flex;
    align-items: center;
    background: #274C7B;
    color: #fff;

    &:hover {
      background: #2990E8 !important;
      color: #fff !important;
    }
  }

  .arco-icon {
    &:not(.arco-icon-down) {
      font-size: 18px;
    }
  }
}
</style>
